// Consent-gated: Sentry does not initialize until Error Tracking opt-in.
import * as Sentry from "@sentry/react";
import { getCookieConsent } from "~/lib/cookie-consent-state";
import { SENTRY_DATA_COLLECTION } from "~/lib/sentry-data-collection";
import { scrubSentryEvent } from "~/lib/security/sentry-event-scrubber";

export function initSentryClient() {
  if (typeof window === "undefined") return;
  if (!getCookieConsent()?.errorTracking) return;

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    // Transactions/spans have no allowlisted client policy; fail closed.
    tracesSampleRate: 0,
    beforeSendTransaction() {
      return null;
    },
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    dataCollection: SENTRY_DATA_COLLECTION,
    beforeSend(event) {
      return scrubSentryEvent(event, {
        environment: import.meta.env.MODE,
        release: import.meta.env.VITE_SENTRY_RELEASE,
      }) as unknown as typeof event;
    },
  });
}
